export default __webpack_public_path__ + "static/sie_europe-1752f1bd8cbe1c70f1ee7f7366e96796.webp";